import { render, staticRenderFns } from "./HelpCenterBackup.vue?vue&type=template&id=5eb1d8d6&scoped=true"
import script from "./HelpCenterBackup.vue?vue&type=script&lang=js"
export * from "./HelpCenterBackup.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterBackup.vue?vue&type=style&index=0&id=5eb1d8d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1d8d6",
  null
  
)

export default component.exports